import request from '@/utils/request'

let statisticalApi = {
  /*业务员列表*/
  salesmanlist(data) {
    return request._post('/shop/plus.statistical.index/index', data);
  },
  /*分销订单*/
  agentOrder(data) {
    return request._post('/shop/plus.statistical.index/orederList', data);
  },

}
export default statisticalApi;



// WEBPACK FOOTER //
// ./src/api/statistical.js